﻿/**
* DevExpress Analytics (query-builder\dataSource\_utils.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _arrayutils_1 = require("../../core/utils/_arrayutils");
var _getNameHelpers_1 = require("../../core/internal/_getNameHelpers");
function generateQueryUniqueName(queries, query) {
    var name = (query.name() || query.generateName()).replace('.', '_');
    return _arrayutils_1.findFirstItemMatchesCondition(queries, function (item) { return item.name() === name; }) ?
        _getNameHelpers_1.getUniqueNameForNamedObjectsArray(queries, name + '_') : name;
}
exports.generateQueryUniqueName = generateQueryUniqueName;
